import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

interface YouTubeModalProps {
    fileUrl: string;
    subUrl?: string | null | undefined;
    onClose: () => void;
}

const YouTubeModal: React.FC<YouTubeModalProps> = ({ fileUrl, subUrl, onClose }) => {
    
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const getYoutubeVideoId = (url:string) => {
        if (!url) return null;

        const regex =
            /(?:youtube\.com\/(?:.*v=|.*\/|embed\/|shorts\/)|youtu\.be\/)([^#&?]{11})/;

        const match = url.match(regex);

        return match ? match[1] : null;
    }
    const handleShare = async (url: string) => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: "Youtube",
                    text: "Segue o video:",
                    url: url  // usa a URL diretamente
                });
            } catch (error) {
                console.error("Erro:", error);
            }
        } else {
            alert("Compartilhamento não suportado.");
        }
    };
    return (
        <div style={overlayStyle}>
            <div style={{...modalStyle,background:'#002510'}}>
                {/* Cabeçalho com botões */}
                <div style={{...headerStyle,background:'#002510', border:0}}>
                    <div>
                        <button
                            className="btn btn-success"
                            type='button'
                            onClick={()=>{handleShare(fileUrl)}}
                        >
                            Compartilhar
                        </button>
                        <button
                            className="btn btn-success"
                            style={{marginLeft:10}}
                            type='button'
                            onClick={()=>{window.open((subUrl??fileUrl), '_blank');}}
                        >
                            Ver mais
                        </button>
                    </div>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={onClose}
                    >
                       X Fechar
                    </button>
                </div>

                {/* Visualizador PDF */}
                <div style={{}}>
                    <iframe
                        width="100%"
                        height="400"
                        src={`https://www.youtube.com/embed/${getYoutubeVideoId(fileUrl)}`}
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    );
};

const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1050,
    padding: '10px',
};

const modalStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    borderRadius: '8px',
    maxWidth: '700px',
    width: '100%',
    minHeight: 400,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
};

const headerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px',
    borderBottom: '1px solid #ddd',
    backgroundColor: '#f8f9fa',
};

export default YouTubeModal;
